var DefaultVINValue = "Enter VIN";
 var cannotLoadAjax = "Can not process your request";
 var innovaApiUrl = "https://dev.innova.com/api";//$("#InnovaApiUrl").val();
 var innovaApiKey = "H/Fp0tLdQVwq/DwPWwBcH7Rzacrf+59K2Ko9cmxxe648ygmh9TT7vJrmyyVf9vRh";//$("#InnovaKey").val();
 var makeText = 'Make';
 var yearText = 'Year';
 var modelText = 'Model';
 var loadingText = 'Loading';
 var engineText = 'Engine';
 var toolText = 'Tool';
 var oldTools = ['3020d','3030h','3040e','3100j','3120f','3130f','3140g','3150f','3160g','6100p','7100p'];
 var engineTools = ['5610','5510','5512','5410','5310','5210','5110','5010','1000','3020RS','3030RS','3040RS','3100RS','3120RS','3130RS','3150RS','3160RS','3170RS','3215RS','5100RS','5160RS','6000P','6030P','6100P','6200P','7100P','3011','3013','D201'];

$(document).ready(function () {
    	
    $("#errorDiv").hide();
      
    initCoveragePage();
	toggleCoverage();
  
    //$("#Tool").change(function () {
    //    var tool = $("#Tool").val();
    //    //var validEngine = tool == "" || newTools.includes(tool); 
    //    //if (validEngine) {
    //    //    $("#vehicleInfoText").html("Enter Vehicle, Year, Make, Model and Engine");
    //    //    $("#enginePanel").show();
    //    //} else {
    //    //    $("#vehicleInfoText").html("Enter Vehicle, Year, Make and Model");
    //    //    $("#enginePanel").hide();
    //    //}
    //    GetYearSelectList();
    //});

    $("#Retailer").change(function () {
        GetToolsSelectList();
    });

    $("#Tool").change(function () {
      if(!checkSpecialTool()){
        var tool = $("#Tool").val();
        if (oldTools.includes(tool)) {
          	$("#engineTypeContent").hide();
        } else {
            $("#engineTypeContent").show();
        }
      	$("#Year").removeClass("inv-error");
        $("#Make").removeClass("inv-error");
        $("#ModelName").removeClass("inv-error");
        $("#EngineType").removeClass("inv-error");
        $("#Vin").removeClass("inv-error");
      }
    });

    $("#Year").change(function () { 
        GetMakeSelectList();
    });

    $("#Make").change(function () { 
        GetModelSelectList();
    });

    $("#ModelName").change(function () {
        GetEngineTypeSelectList();
    });
    
	$("#ToolYear").change(function () { 
        GetToolMakes();
    });

    $("#ToolMake").change(function () { 
        GetToolModels();
    });

    $("#ToolModelName").change(function () {
        GetToolEngineTypes();
    });
	
    $("#Vin").change(function () {
        validVin();
    });

    $("#Vin").blur(function () {
        validVin();        
    });

    $('#Vin').keyup(function (event) {
        if (event.keyCode != 13) {
            var vinLength = 17 - $('#Vin').val().length;
            $("#vinCount").html(vinLength);
        }
    });

    $('#frmCoverage').keypress(function (event) {
        if (event.keyCode == 13) {
            searchCompatibilities();
            return false;
        }
    });
  

  /*
  var detailPage = $("#ForProductDetail").val();
  if(detailPage == undefined || detailPage == null || !detailPage){                                      
    var clicked = false, base = 0;
    $('#results').on({
        mousemove: function(e) {
            clicked && function(xAxis) {
                var _this = $(this);
                if(base > xAxis) {
                    base = xAxis;
                    _this.css('margin-left', '-=1px');
                }
                if(base < xAxis) {
                    base = xAxis;
                    _this.css('margin-left', '+=1px');
                }
            }.call($(this), e.pageX);
        },
        mousedown: function(e) {
            clicked = true;
            base = e.pageX;
        },
        mouseup: function(e) {
            clicked = false;
            base = 0;
        }
    });
    
    //checkWidth(); 
    
  }
  */
  
});


function toggleCoverage(){
  	var tool = $("#Tool").val();
	var coverageTools = $("#CoverageTools").val();
  	$("#coverageLink").hide();
    $("#shopify-section-coverage-template").hide(); 
  
    if(tool != undefined && tool != null && coverageTools != undefined && coverageTools != null && coverageTools != "" && 
       	coverageTools.toUpperCase().indexOf(tool.toUpperCase()) >= 0){
        $("#coverageLink").show();
      	$("#shopify-section-coverage-template").show();             
    }
}

function validVin() {
    var text = $('#Vin').val().toUpperCase();
    text = text.replace(/Q/g, "0").replace(/O/g, "0").replace(/I/g, "1").replace(/L/g, "1");
    $('#Vin').val(text);
    var vinLength = 17 - $('#Vin').val().length;
    $("#vinCount").html(vinLength);
}

function validateCoverageForm(validEngine) {
	$("#Year").removeClass("required").removeClass("inv-error");
	$("#Make").removeClass("required").removeClass("inv-error");
	$("#ModelName").removeClass("required").removeClass("inv-error");
	$("#EngineType").removeClass("required").removeClass("inv-error");
	$("#Vin").removeClass("required").removeClass("inv-error");
		
    if ($("#Vin").val() == "" && $("#MakeOnly").val() == "") {
        $("#Year").addClass("required");
        $("#Make").addClass("required");
        $("#ModelName").addClass("required");
        if(validEngine){
          $("#EngineType").addClass("required");
        }else{
          $("#EngineType").removeClass("required").removeClass("inv-error");
        }
        $("#Vin").removeClass("required").removeClass("inv-error");
    } else if($("#MakeOnly").val() == ""){
        $("#Year").removeClass("required").removeClass("inv-error");
        $("#Make").removeClass("required").removeClass("inv-error");
        $("#ModelName").removeClass("required").removeClass("inv-error");
        $("#EngineType").removeClass("required").removeClass("inv-error");

        $("#Vin").addClass("required");
    }

    if(!checkRequiredFields('coverageChecker')){
      return false;
    }
  /*
    if (!$("#frmCoverage")[0].checkValidity()) {
        $("#frmCoverage").addClass("was-validated");
        return false;
    }
    */
  
    return true;
}

function searchCompatibilities() {
    $("#errorDiv").hide();
  
    var tool = $("#Tool").val();
    var validEngine = $("#EngineType option").length > 1 && (tool == "" || !oldTools.includes(tool.toLowerCase()));
    var isValidForm = validateCoverageForm(validEngine);

    if (isValidForm) {        
        if ($("#Year").val() !== "" && $("#Make").val() !== "" && $("#ModelName").val() !== "" && $("#Vin").val() === "") {
            $("#Vin").val("");
        }
      
        $("#searchCoverageBtn").attr('disabled','disabled');      
        $('#ModalContentAjax').modal("show");		

		var year = $("#Year").val();
		var make = $("#Make").val();
		var modelName = $("#ModelName").val();
		var engineType = $("#EngineType").val();
		var vin = $("#Vin").val();
		var retailer = $("#Retailer").val();
        var forProductDetail = (tool != undefined && tool != "");
		if (year == "" && make == "" && modelName == "" && (engineType == undefined || engineType == ""))
		{
			make = $("#MakeOnly").val();			 
		}
		var requestData = "ForProductDetail="+ forProductDetail +"&Tool="+tool +"&Year="+year + "&Make="+ make + "&ModelName=" + modelName + "&EngineType=" + engineType + "&Vin="+ vin + "&Retailer=" + retailer;


      try{
        xhr = $.ajax({
            type: "POST",
            crossOrigin: true,
            url: innovaApiUrl + "/Coverages/Validate",
            data: requestData,//$("#frmCoverage").serialize(),
            beforeSend: function (xhr) {
                xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
            },
            error: function () {
              $('#ModalContentAjax').modal("hide");
              $("#searchCoverageBtn").removeAttr('disabled');
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");

                if (!result.message.success) {
                      $("#searchCoverageBtn").removeAttr('disabled');
                    $("#errorDiv").html(result.message.description);
                    $("#errorDiv").show();
                    return false;
                } else {
                    //return true;
                    //$("#frmCoverage").submit();

                    xhr = $.ajax({
                        type: "POST",
                        url: innovaApiUrl + "/Coverages/Search",
                        data: requestData,//$("#frmCoverage").serialize(),
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
                        },
                        error: function () {
                            $('#ModalContentAjax').modal("hide");
                            $("#searchCoverageBtn").removeAttr('disabled');
                          alert(cannotLoadAjax);
                        },
                        success: function (result) {
                            var detailPage = $("#ForProductDetail").val();
                            if (result.message.success) {                               
                                //if (result.hasData) {
                              //try{
                                  $("#results").html(result.coverageResult);  
                                    $("#searchCoverageBtn").removeAttr('disabled');
                                  if (!detailPage && result.hasData) {
                                     var freeze_Table = new FreezeTable({
                                        namespace: "freeze-table"          
                                      });
                                      freeze_Table.freezeTable();
                                    
                                      var dragdrop = new DragScroll({
                                          classContainer: "freeze-table"
                                      });
                                      dragdrop.doDragScroll();
                                  }
                                //}catch(e)
                                //{
                                //  alert(e);
                                //  $('#ModalContentAjax').modal("hide");
                                //  $("#searchCoverageBtn").removeAttr('disabled');
                                //}
                              
                                //} else{
                                //  $("#errorDiv").html("Data not found!");                                    
                                //}                                
                            } else {
                              if (detailPage) {
                                $("#errorDiv").html("VIN maybe incorrect. Please check your VIN and try again");
                                $("#errorDiv").show();
                              } else {
                                  $("#errorDiv").html("Data not found!");
                              }                                
                            }
                              
                              $('#ModalContentAjax').modal("hide");
                            $("#searchCoverageBtn").removeAttr('disabled');
                        }
                    });
                }
              }
          });
        }catch(e)
        {
        	$('#ModalContentAjax').modal("hide");
          $("#searchCoverageBtn").removeAttr('disabled');
        }
      
    }

    return false;
}

function validateCoverage(validEngine) {
    if ($("#Year").val()=="" && $("#Make").val() == "" && $("#ModelName").val()=="") {
      	$("#Year").removeClass("required");
        $("#Make").removeClass("required");
        $("#ModelName").removeClass("required");
        $("#EngineType").removeClass("required");

        $("#Vin").addClass("required");      
        
    } else {
        $("#Year").addClass("required");
        $("#Make").addClass("required");
        $("#ModelName").addClass("required");
        if(validEngine){
          $("#EngineType").addClass("required");
        }else{
          $("#EngineType").removeClass("required").removeClass("inv-error");
        }
        $("#Vin").removeClass("required");
    }

    if(!checkRequiredFields('coverageChecker')){
      return false;
    }  
  
    return true;
}
function checkCompatibilities() {
    $("#errorDiv").hide();
    
    var tool = $("#Tool").val();
    var validEngine = $("#EngineType option").length > 1 && (tool == "" || !oldTools.includes(tool.toLowerCase()));
    var isValidForm = validateCoverage(validEngine);

    if (isValidForm) {
        if ($("#Year").val() !== "" && $("#Make").val() !== "" && $("#ModelName").val() !== "" && $("#Vin").val() === "") {
            $("#Vin").val("");
        }
      
        $("#searchCoverageBtn").attr('disabled','disabled');      
        $('#ModalContentAjax').modal("show");
      try{
        xhr = $.ajax({
            type: "POST",
            crossOrigin: true,
            url: innovaApiUrl + "/Coverages/Validate",
            data: $("#frmCoverage").serialize(),
            beforeSend: function (xhr) {
                xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
            },
            error: function () {
              $('#ModalContentAjax').modal("hide");
              $("#searchCoverageBtn").removeAttr('disabled');
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");

                if (!result.message.success) {
                      $("#searchCoverageBtn").removeAttr('disabled');
                    $("#errorDiv").html(result.message.description);
                    $("#errorDiv").show();
                    return false;
                } else {                  
                      var retailer = $("#Retailer").val();
                    var tool = $("#Tool").val();
                    var year = $("#Year").val();
                    var make = $("#Make").val();
                    var modelName = $("#ModelName").val();
                    var engineType = $("#EngineType").val();
                      var vin = $("#Vin").val();
                      var queryRequest = "retailer=" + retailer + "&tool="+ tool +"&year="+ year+"&make="+ make
                                      + "&modelName=" + modelName +"&engineType="+ engineType + "&vin=" + vin;
                  window.location = "/pages/coverage?" + queryRequest;
                  
                }
            }
        });
      }catch(e)
      {
          $('#ModalContentAjax').modal("hide");
        $("#searchCoverageBtn").removeAttr('disabled');
      }       
    }

    return false;
}


 function checkWidth() {
   var windowsize = $(window).width();
   if (windowsize > 767) {
     //if the window is greater than 767px wide then turn on fixedNavbar.
     $('.freeze-table').freezeTable({ fixedNavbar: '.inv-navbar' });
   } else {
     $('.freeze-table').freezeTable({});
   }
 }

function queryDedault(){
  var retailer = QUERY_STRING("retailer"); 
  var tool = QUERY_STRING("tool"); 
  var year = QUERY_STRING("year"); 
  var make = QUERY_STRING("make"); 
  var modelName = QUERY_STRING("modelName"); 
  var engineType = QUERY_STRING("engineType"); 
  var vin = QUERY_STRING("vin");  

  if(retailer != null && retailer != ""){
   $("#Retailer").val(retailer);
  }
  if(tool != null && tool != ""){
    $("#Tool").val(tool);
  }
   if((year != null && year != "") || (make != null && make != "")
     ||(modelName != null && modelName != "") || (engineType != null && engineType != "")){
    $("#Retailer").val(retailer);
    $("#Tool").val(tool);
     
     if(vin != ""){   
       $("#Vin").val(vin);
     }
    if(year != null && year != ""){      
      $("#Year").val(year);
      //GetMakeSelectList(decodeURI(make));
      var tool = $("#Tool").val();
      var year = $("#Year").val();
      if (year == "") {
          $("#Make").html("<option value=''>" + makeText + "</option>");
          $("#ModelName").html("<option value=''>" + modelText + "</option>");
          $("#EngineType").html("<option value=''>" + engineText + "</option>");
          $("#EngineType").change();
          $("#Make").change();
          $("#ModelName").change();
          return false;
      }
      $("#Make").html("<option value=''>" + loadingText + "...</option>");
      var url = innovaApiUrl + "/Coverages/" + year + "/Makes/?r=" + Math.random();

      $('#ModalContentAjax').modal("show");
      xhr = $.ajax({
          type: "POST",
          crossOrigin: true,
          url: url,
          beforeSend: function (xhr) {
              xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
          },
          error: function () {
              $('#ModalContentAjax').modal("hide");
              alert(cannotLoadAjax);
          },
          success: function (data) {
              var result = data.makes;
              var options = "<option value=''>" + makeText + "</option>"; 
              for (var i = 0; i < result.length; i++) {
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
              }
              $("#Make").html(options);
              $("#ModelName").html('<option value="">Model</option>');
              $("#EngineType").html("<option value=''>" + engineText + "</option>");
              
              if(make != ""){ 
                $("#Make").val(make);                
    
                $("#ModelName").html("<option value=''>" + loadingText + "...</option>");
                url = innovaApiUrl + "/Coverages/" + year + "/" + make + "/Models/?r=" + Math.random();
               
                $.ajax({
                    type: "POST",
                    crossOrigin: true,
                    url: url,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
                    },
                    error: function () {
                        $('#ModalContentAjax').modal("hide");
                        alert(cannotLoadAjax);
                    },
                    success: function (data) {
                        var result = data.models;
                        var options = "<option value=''>" + modelText + "</option>";
                        for (var i = 0; i < result.length; i++) {
                            options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                        }
                        $("#ModelName").html(options);
                        $("#EngineType").html("<option value=''>" + engineText + "</option>");
                       
                        if(modelName != ""){ 
                          $("#ModelName").val(modelName);
                          
                          $("#EngineType").html("<option value=''>" + loadingText + "...</option>");
                          url = innovaApiUrl + "/Coverages/" + year + "/" + make + "/" + encodeURIComponent(modelName) + "/engines/?r=" + Math.random();
                         
                          $.ajax({
                              type: "POST",
                              crossOrigin: true,
                              url: url,
                              beforeSend: function (xhr) {
                                  xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
                              },
                              error: function () {
                                  $('#ModalContentAjax').modal("hide");
                                  alert(cannotLoadAjax);
                              },
                              success: function (data) {
                                  var result = data.engines;
                                  var options = result.length == 1? "": "<option value=''>" + engineText + "</option>";
                                  for (var i = 0; i < result.length; i++) {
                                      options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                                  }
                                  $("#EngineType").html(options);
                                  //$('.selectpicker').selectpicker('refresh');

                                  if(engineType != ""){ 
                                    $("#EngineType").val(engineType);                                    
                                  }     
                                 //checkCompatibilities();
                                  xhr = $.ajax({
                                  type: "POST",
                                  url: innovaApiUrl + "/Coverages/Search",
                                  data: $("#frmCoverage").serialize(),
                                  beforeSend: function (xhr) {
                                      xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
                                  },
                                  error: function () {
                                      $('#ModalContentAjax').modal("hide");
                                      $("#searchCoverageBtn").removeAttr('disabled');
                                      alert(cannotLoadAjax);
                                  },
                                  success: function (result) {
                                      var detailPage = $("#ForProductDetail").val();
                                      if (result.message.success) {                               

                                            $("#results").html(result.coverageResult);  
                                            $("#searchCoverageBtn").removeAttr('disabled');
											
                                            if (!detailPage && result.hasData) {
                                               var freeze_Table = new FreezeTable({
                                                  namespace: "freeze-table"          
                                                });
                                                freeze_Table.freezeTable();

                                                var dragdrop = new DragScroll({
                                                  classContainer: "freeze-table"
                                                });
                                                dragdrop.doDragScroll();
                                            }

                                      } else {
                                        if (detailPage) {
                                          $("#errorDiv").html("VIN maybe incorrect. Please check your VIN and try again");
                                          $("#errorDiv").show();
                                        } else {
                                            $("#errorDiv").html("Data not found!");
                                        }                                
                                      }                          	

                                      $("#searchCoverageBtn").removeAttr('disabled');
                                  }
                              });
                              }
                          });
                        }
                        
                    }
                });
              }
             
              $('#ModalContentAjax').modal("hide");
          }
      });

    } 
    
  }
  else if(vin != ""){   
    $("#Vin").val(vin);
    xhr = $.ajax({
      type: "POST",
      url: innovaApiUrl + "/Coverages/Search",
      data: $("#frmCoverage").serialize(),
      beforeSend: function (xhr) {
        xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
      },
      error: function () {
        $('#ModalContentAjax').modal("hide");
        $("#searchCoverageBtn").removeAttr('disabled');
        alert(cannotLoadAjax);
      },
      success: function (result) {
        var detailPage = $("#ForProductDetail").val();
        if (result.message.success) {                               

          $("#results").html(result.coverageResult);  
          $("#searchCoverageBtn").removeAttr('disabled');
          if (result.hasData) {
            var freeze_Table = new FreezeTable({
              namespace: "freeze-table"          
            });
            freeze_Table.freezeTable();

            var dragdrop = new DragScroll({
              classContainer: "freeze-table"
            });
            dragdrop.doDragScroll();
          }

        } else {
          if (detailPage) {
            $("#errorDiv").html("VIN maybe incorrect. Please check your VIN and try again");
            $("#errorDiv").show();
          } else {
            $("#errorDiv").html("Data not found!");
          }                                
        }                          	

        $("#searchCoverageBtn").removeAttr('disabled');
      }
    });
  }
  return;
}

function initCoveragePage(){
   var detailPage = $("#ForProductDetail").val();
  
  if(detailPage){	  
	tongleFeatureCoverage();
  }
   else{
     
  	 xhr = $.ajax(
      {
        type: "GET",
        url: innovaApiUrl + "/coverages/start",
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        //dataType: "text/html",
        error: function (xhr, status, error) {
          
        },
        success: function (data) {
          var result = data.resultObj;
          if(result.retailers.length > 0){
            var items = "<option value='' >Retailer</option>";
            $.each(result.retailers, function (i, item) {             
                items += "<option value='" + item.key + "'>" + item.value + "</option>";             
            });
            $("#Retailer").html(items); 
          }
          
          if(result.years.length > 0){
            var items = "<option value='' >"+ yearText +"</option>";
            $.each(result.years, function (i, year) {             
                items += "<option value='" + year + "'>" + year + "</option>";             
            });
            $("#Year").html(items); 
          }
          
          if(result.tools.length > 0){
            var items = "<option value='' >"+ toolText +"</option>";
            $.each(result.tools, function (i, tool) {             
                items += "<option value='" + tool + "'>" + tool + "</option>";             
            });
            $("#Tool").html(items); 
          }
          
          queryDedault();
        }
      });
   }
  
}

function checkSpecialTool(){
  var tool = $("#Tool").val();
  var detailPage = $("#ForProductDetail").val();
  if(tool == "7111" && !detailPage){  
    var queryRequest = "sku="+ tool; 
    var redirectUrl = 'https://www.innova.com/pages/product-detail-testing?'+ queryRequest;    
    //https://www.innova.com/collections/all/products/smart-diagnostic-system-obd2-tablet-7111#shopify-section-coverage-template
    window.location = redirectUrl;
    
    return true;
  } 

  return false;
} 

function GetToolsSelectList() {
    var retailer = $("#Retailer").val();
  	if(retailer == "")
    	retailer = "''";
    var url = innovaApiUrl + "/Coverages/" + retailer +"/tools/?r=" + Math.random();
   
    $('#ModalContentAjax').modal("show");
    $.ajax({
        type: "GET",
        crossOrigin: true,
        url: url,
      	beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            $('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
          	var result = data.tools;
            var options = "<option value=''>" + toolText + "</option>";
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#Tool").html(options);
            //$('.selectpicker').selectpicker('refresh');

            $('#ModalContentAjax').modal("hide");
        }
    });
}

function GetYearSelectList() {   
    var url = innovaApiUrl + "/Coverages/Years/?r=" + Math.random();
    //$('#ModalContentAjax').modal("show");
    $.ajax({
        type: "GET",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            //$('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
          	var result = data.years;
            var options = "<option value=''>" + yearText + "</option>";
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#Year").html(options);
            $("#Make").html("<option value=''>" + makeText + "</option>");
            $("#ModelName").html("<option value=''>" + modelText + "</option>");
            $("#EngineType").html("<option value=''>" + engineText + "</option>");

            //$('.selectpicker').selectpicker('refresh');

            //$('#ModalContentAjax').modal("hide");
        }
    });
}

function GetMakeSelectList(selectedMake) {
    var tool = $("#Tool").val();
    var year = $("#Year").val();
    if (year == "") {
        $("#Make").html("<option value=''>" + makeText + "</option>");
        $("#ModelName").html("<option value=''>" + modelText + "</option>");
        $("#EngineType").html("<option value=''>" + engineText + "</option>");
        $("#EngineType").change();
        $("#Make").change();
        $("#ModelName").change();
        return false;
    }
    $("#Make").html("<option value=''>" + loadingText + "...</option>");
    var url = innovaApiUrl + "/Coverages/" + year + "/Makes/?r=" + Math.random();
    
    $('#ModalContentAjax').modal("show");
    xhr = $.ajax({
        type: "POST",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            $('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
            var result = data.makes;
            var options = "<option value=''>" + makeText + "</option>"; 
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#Make").html(options);
            $("#ModelName").html('<option value="">Model</option>');
            $("#EngineType").html("<option value=''>" + engineText + "</option>");
            //$('.selectpicker').selectpicker('refresh');

            if(selectedMake != undefined && selectedMake != null){ 
              $("#Make").val(selectedMake);
            }
            $('#ModalContentAjax').modal("hide");
        }
    });

}

function GetModelSelectList(selectedModel) {
    var tool = $("#Tool").val();
    var make = $("#Make").val();
    var year = $("#Year").val();

    if (make == "") {
        $("#ModelName").html("<option value=''>" + modelText + "</option>");
        $("#EngineType").html("<option value=''>" + engineText + "</option>");
        $("#EngineType").change();
        $("#ModelName").change();
        return false;
    }
    $("#ModelName").html("<option value=''>" + loadingText + "...</option>");
    var url = innovaApiUrl + "/Coverages/" + year + "/" + make + "/Models/?r=" + Math.random();

    $('#ModalContentAjax').modal("show");
    $.ajax({
        type: "POST",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            $('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
          	var result = data.models;
            var options = "<option value=''>" + modelText + "</option>";
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#ModelName").html(options);
            $("#EngineType").html("<option value=''>" + engineText + "</option>");
            //$('.selectpicker').selectpicker('refresh');

            if(selectedModel != undefined && selectedModel != null){ 
              $("#ModelName").val(selectedModel);
            }
            $('#ModalContentAjax').modal("hide");
        }
    });
}

function GetEngineTypeSelectList(selectedEngine) {
    var tool = $("#Tool").val();
    var make = $("#Make").val();
    var year = $("#Year").val();
    var model = $("#ModelName").val();

    if (model == "") {
        $("#EngineType").html("<option value=''>" + engineText + "</option>");
        $("#EngineType").change();
        return false;
    }
    $("#EngineType").html("<option value=''>" + loadingText + "...</option>");
    var url = innovaApiUrl + "/Coverages/" + year + "/" + make + "/" + encodeURIComponent(model) + "/engines/?r=" + Math.random();
        
  	$('#ModalContentAjax').modal("show");
    $.ajax({
        type: "POST",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            $('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
           	var result = data.engines;
          	var options = result.length == 1? "": "<option value=''>" + engineText + "</option>";
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#EngineType").html(options);
            //$('.selectpicker').selectpicker('refresh');

            if(selectedEngine != undefined && selectedEngine != null){ 
              $("#EngineType").val(selectedEngine);
            }
            $('#ModalContentAjax').modal("hide");
        }
    });
}

function QUERY_STRING(key) {
  var val = "";
  query = window.location.search.substring(1);
  pairs = query.split("&");
  for (i = 0; i < pairs.length; i++) {
    pair = pairs[i].split("=");
    if (pair[0] == key) {
      val = decodeURI(pair[1]);
      break;
    }
  }
  return val;
}
function tongleFeatureCoverage(){
  var sku = QUERY_STRING("sku");
  if(sku !=""){
    $("#Tool").val(sku);
  }
  
  InitCoverageForTool();
  
  if($("#Tool").val() == "7111"){
  	$("#featureCoverage").show();
    //$("#featureCoverageTitle").show();
    $("#coverageChecker").hide();
    //$("#coverageTitle").hide();    
  }else{
  	$("#featureCoverage").hide();
    //$("#featureCoverageTitle").hide();
    $("#coverageChecker").show();
    //$("#coverageTitle").show();
    
    //GetYearSelectList();    
    if(engineTools.includes(sku.toUpperCase())){
    	$("#EngineTypeDiv").show();
    }else{
    	$("#EngineTypeDiv").hide();
    }
    
  }
}

function validateFeatureCoverageForm() {
	 if ($("#ToolMakeOnly").val() == "") {
        $("#ToolYear").addClass("required");
        $("#ToolMake").addClass("required");
        $("#ToolModelName").addClass("required");
		$("#ToolEngineType").addClass("required");
		
        $("#ToolMakeOnly").removeClass("required").removeClass("inv-error");		
		
    } else {
        $("#ToolYear").removeClass("required").removeClass("inv-error");
        $("#ToolMake").removeClass("required").removeClass("inv-error");
        $("#ToolModelName").removeClass("required").removeClass("inv-error");
        $("#ToolEngineType").removeClass("required").removeClass("inv-error");

        $("#ToolMakeOnly").addClass("required");
    }

	if(!checkRequiredFields("featureCoverage")){
	  return false;
	}
    return true;
}

function searchFeatureCompatibilities() {
    $("#errorDiv").hide();
    
    var tool = $("#Tool").val();
    var toolYear = $("#ToolYear").val();
    var toolMake = $("#ToolMake").val();
    var toolModelName = $("#ToolModelName").val();
	var toolEngineType = $("#ToolEngineType").val();
    var isValidForm = validateFeatureCoverageForm();
	
    if (isValidForm) {
		if ($("#ToolYear").val()=="" && $("#ToolMake").val() == "" && $("#ToolModelName").val()=="" && $("#ToolEngineType").val() == "")
		{
			toolMake = $("#ToolMakeOnly").val();			 
		}
        var requestData = "ForProductDetail=true&Tool="+tool +"&Year="+toolYear + "&Make="+ toolMake + "&ModelName=" + toolModelName + "&EngineType=" + toolEngineType;
      
        $("#searchFeatureCoverageBtn").attr('disabled','disabled');      
        $('#ModalContentAjax').modal("show");
      try{      

        xhr = $.ajax({
          type: "POST",
          url: innovaApiUrl + "/Coverages/Search",
          data: requestData,
          beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
          },
          error: function () {
            $('#ModalContentAjax').modal("hide");
            $("#searchFeatureCoverageBtn").removeAttr('disabled');
            alert(cannotLoadAjax);
          },
          success: function (result) {
            var detailPage = $("#ForProductDetail").val();
            if (result.message.success) {                               
              $("#featureCoverageResult").html(result.coverageResult);  
              $("#searchFeatureCoverageBtn").removeAttr('disabled');                                  
            } else {
              if (detailPage) {
                $("#errorDiv").html("VIN maybe incorrect. Please check your VIN and try again");
                $("#errorDiv").show();
              } else {
                $("#errorDiv").html("Data not found!");
              }                                
            }

            $('#ModalContentAjax').modal("hide");
            $("#searchFeatureCoverageBtn").removeAttr('disabled');
          }
        });
                
      }catch(e)
      {
      	$('#ModalContentAjax').modal("hide");
        $("#searchFeatureCoverageBtn").removeAttr('disabled');
      }
    }

    return false;
}


function GetToolMakesOnly(selectedMake) {
    var tool = $("#Tool").val();
    var url = innovaApiUrl + "/Coverages/" + tool + "/0/tool-makes/?r=" + Math.random();    
   
  $('#ModalContentAjax').modal("show");
    xhr = $.ajax({
        type: "POST",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
          $('#ModalContentAjax').modal("hide");
          alert(cannotLoadAjax);
        },
        success: function (data) {
            var result = data.makes;
            var options = "<option value=''>" + makeText + "</option>"; 
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#ToolMakeOnly").html(options);
            if(selectedMake != undefined && selectedMake != null){ 
              $("#ToolMakeOnly").val(selectedMake);
            }
            $('#ModalContentAjax').modal("hide");
        }
    });

}

function GetToolMakes(selectedMake) {
    var tool = $("#Tool").val();
	var year = $("#ToolYear").val();
    var url = innovaApiUrl + "/Coverages/" + tool  + "/" + year  + "/tool-makes/?r=" + Math.random();    
    if (year == "") {
        $("#ToolMake").html("<option value=''>" + makeText + "</option>");
        $("#ToolModelName").html("<option value=''>" + modelText + "</option>");
        $("#ToolEngineType").html("<option value=''>" + engineText + "</option>");
        $("#ToolEngineType").change();
        $("#ToolMake").change();
        $("#ToolModelName").change();
        return false;
    }
	$('#ModalContentAjax').modal("show");
    xhr = $.ajax({
        type: "POST",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
          $('#ModalContentAjax').modal("hide");
          alert(cannotLoadAjax);
        },
        success: function (data) {
            var result = data.makes;
            var options = "<option value=''>" + makeText + "</option>"; 
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#ToolMake").html(options);
            if(selectedMake != undefined && selectedMake != null){ 
              $("#ToolMake").val(selectedMake);
            }
          
            $("#ToolModelName").html("<option value=''>" + modelText + "</option>");
			$("#ToolEngineType").html("<option value=''>" + engineText + "</option>");
            
            $('#ModalContentAjax').modal("hide");
        }
    });

}

function GetToolModels(selectedModel) {
    var tool = $("#Tool").val();
    var year = $("#ToolYear").val();
    var make = $("#ToolMake").val();
  
    
    if (make == "") {
        $("#ToolModelName").html("<option value=''>" + modelText + "</option>");
        $("#ToolEngineType").html("<option value=''>" + engineText + "</option>");
        $("#ToolEngineType").change();
        $("#ToolModelName").change();
        return false;
    }
    $("#ToolModelName").html("<option value=''>" + loadingText + "...</option>");
    var url = innovaApiUrl + "/Coverages/" + tool + "/"  + year + "/" + make + "/tool-models/?r=" + Math.random();

    $('#ModalContentAjax').modal("show");
    $.ajax({
        type: "POST",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            $('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
          	var result = data.models;
            var options = "<option value=''>" + modelText + "</option>";
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#ToolModelName").html(options);
           
            if(selectedModel != undefined && selectedModel != null){ 
              $("#ToolModelName").val(selectedModel);
            }			
			$("#ToolEngineType").html("<option value=''>" + engineText + "</option>");
			 
            $('#ModalContentAjax').modal("hide");
        }
    });
}

function GetToolEngineTypes(selectedEngine) {
    var tool = $("#Tool").val();
	var year = $("#ToolYear").val();   
	var make = $("#ToolMake").val();   
    var model = $("#ToolModelName").val();

    if (model == "") {
        $("#ToolEngineType").html("<option value=''>" + engineText + "</option>");
        $("#ToolEngineType").change();
        return false;
    }
    $("#ToolEngineType").html("<option value=''>" + loadingText + "...</option>");
    var url = innovaApiUrl + "/Coverages/" + tool + "/" + year + "/" + make + "/" + encodeURIComponent(model) + "/tool-engines/?r=" + Math.random();
        
  	$('#ModalContentAjax').modal("show");
    $.ajax({
        type: "POST",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            $('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
           	var result = data.engines;
          	var options = result.length == 1? "": "<option value=''>" + engineText + "</option>";
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#ToolEngineType").html(options);
            
            if(selectedEngine != undefined && selectedEngine != null){ 
              $("#ToolEngineType").val(selectedEngine);
            }
            $('#ModalContentAjax').modal("hide");
        }
    });
}

function InitCoverageForTool() {
    var tool = $("#Tool").val();
    
    $("#ToolYear").html("<option value=''>" + loadingText + "...</option>");
    var url = innovaApiUrl + "/Coverages/" + tool + "/start/?r=" + Math.random();        
  	
    $.ajax({
        type: "GET",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            alert(cannotLoadAjax);
        },
        success: function (data) {
          var years = data.resultObj.years;   
		  var makes = data.resultObj.makes;
		  if(tool == "7111"){
			  if(years != null){
				var options = years.length == 1? "": "<option value=''>" + yearText + "</option>";                  
				for (var i = 0; i < years.length; i++) {
					options += '<option value="' + years[i] + '">' + years[i] + '</option>';             
				}
				$("#ToolYear").html(options);     
			  }     
			  
			  if(makes != null){
				var options = "<option value=''>" + makeText + "</option>"; 
				for (var i = 0; i < makes.length; i++) {
					options += '<option value="' + makes[i] + '">' + makes[i] + '</option>';
				}
			    $("#ToolMakeOnly").html(options);
			 }
		 }
		 else{			
            var options = "<option value=''>" + yearText + "</option>";
            for (var i = 0; i < years.length; i++) {
                options += '<option value="' + years[i] + '">' + years[i] + '</option>';
            }
            $("#Year").html(options);
			$("#Make").html("<option value=''>" + makeText + "</option>");
            $("#ModelName").html("<option value=''>" + modelText + "</option>");
            $("#EngineType").html("<option value=''>" + engineText + "</option>");		
			
			if(makes != null){
				var options = "<option value=''>" + makeText + "</option>"; 
				for (var i = 0; i < makes.length; i++) {
					options += '<option value="' + makes[i] + '">' + makes[i] + '</option>';
				}
				$("#MakeOnly").html(options);
			}
			
			$("#results").html(data.resultObj.coverageResult);  
			$("#searchCoverageBtn").removeAttr('disabled');
		 }
        }
    });
}

function switchTab(tab){
  $("a.link").removeClass("inv-btn-solid-black").addClass("inv-btn-stroke");
  $("#" + tab + "Link").removeClass("inv-btn-stroke").addClass("inv-btn-solid-black");
  $("div.content").hide();
  $("#" + tab + "Tab").show();
}

